import {CommonStatus} from "@/enums/status";

export class LocationParams {
    page? = 1;
    limit? = 20;
    search?: string;
    type?: number;
    status? = CommonStatus.Active;
}
